import { filter, keys, size } from 'lodash/fp';
import { denormalize } from 'normalizr';
import { createSelector } from 'reselect';

import { toDoSchema } from './schema';
import { toDoIsSuggested } from './utils';

export const toDosSelector = state => state.toDos;

export const selectDenormalizedToDos = createSelector(
  [
    toDosSelector,
    state => state,
  ],
  (toDos, state) => denormalize(keys(toDos), [toDoSchema], state),
);

export const selectSuggestedToDos = createSelector(
  [
    selectDenormalizedToDos,
  ],
  filter(toDoIsSuggested),
);

export const selectSuggestedToDosCount = createSelector([selectSuggestedToDos], size);
